export default __webpack_public_path__ + "static/e-team-1f7762ece0ff72023b0eff6f23239ec9.png";